import { faRepeat } from '@fortawesome/pro-solid-svg-icons/faRepeat';
import { Button } from '@osmosis/react-ui/components/Button';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { FormattedMessage } from 'react-intl';
import { useQuizContext } from '../../../../../context/QuizContext';
import { P } from '@osmosis/react-ui/components/Text';
import { QuizSettings } from '../../../../../lib/shared/quiz/quizSetting';

const colorStyle = {
  color: 'gray60',
  ':hover': {
    color: 'gray80',
  },
};

/**
 * ReverseQuizButtons.
 */
export const ReverseQuizButtons = () => {
  const { updateQuizSetting, quizSettings } = useQuizContext();

  return (
    <Button
      data-testid="reverse-order-btn"
      aria-pressed={!!quizSettings?.[QuizSettings.BUTTONS_REVERSED]}
      fontSize={2}
      mt={3}
      variant={'transparent'}
      sx={{
        marginTop: 3,
        padding: '0',
        ':hover': {
          background: 'transparent',
        },
        ':active': {
          background: 'transparent',
        },
      }}
      onClick={() =>
        updateQuizSetting(
          QuizSettings.BUTTONS_REVERSED,
          !quizSettings[QuizSettings.BUTTONS_REVERSED],
        )
      }
    >
      <P fontSize="15px" sx={colorStyle}>
        <Icon icon={faRepeat} size="sm" style={{ marginRight: '2px' }} />
        <FormattedMessage
          defaultMessage="Reverse order"
          id="reverse-order-btn.text"
        />
      </P>
    </Button>
  );
};
